<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row class="mt-2">
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-text-field
                flat
                dense
                outlined
                v-model="search"
                placeholder="Search"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-checkbox v-model="po" label="PO"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-checkbox v-model="buffer" label="Buffer"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-btn color="success" @click="initialize"><v-icon>mdi-magnify</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>
      <template v-slot:item.journalId="{ item }">
        <span @click="open(item)">{{ item.journalId }}</span>
      </template>
      <template v-slot:item.doNumber="{ item }">
        <ul>
          <li v-for="(data, index) in item.listDo" :key="index">{{ data.doNumber }}</li>
        </ul>
      </template>
      <template v-slot:item.hppAmount="{ item }">
        {{ formatPrice(item.hppAmount) }}
      </template>
      <template v-slot:item.invoiceAmount="{ item }">
        {{ formatPrice(item.invoiceAmount) }}
      </template>
      <template v-slot:item.amount="{ item }">
        {{ formatPrice(item.amount) }}
      </template>
      <template v-slot:item.hasBomList="{ item }">
        {{ item.hasBomList ? "Ada" : "Kosong" }}
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="1200" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">List DO</span>
        </v-card-title>
        <v-card-text>
          <detail-hpp :item="item"></detail-hpp>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="close">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DetailHpp from "./DetailHpp.vue";
export default {
  name: "hpp",
  components: {
    DetailHpp,
  },
  data: () => ({
    search: "",
    dialog: false,
    buffer: false,
    po: false,
    item: {},
    items: [],
    headers: [
      {
        id: 1,
        text: "Trans ID",
        value: "journalId",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 2,
        text: "Customer",
        value: "customerName",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "PO#",
        value: "poNumber",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "DO#",
        value: "doNumber",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 4,
        text: "INV#",
        value: "invoiceNumber",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Date",
        value: "journalDate",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Journal Amount",
        value: "hppAmount",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Invoice Amount",
        value: "invoiceAmount",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "HPP Amount",
        value: "amount",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "BOM",
        value: "hasBomList",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Product Only",
        value: "countProductOnly",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
  }),

  methods: {
    async initialize() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("inventory/getHppBySearch", {
          search: this.search,
          buffer: this.buffer,
          po: this.po,
        })
        .then(response => {
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    close() {
      this.dialog = false;
    },
    open(item) {
      this.item = item;
      this.dialog = true;
    },
    onChangeBuffer() {
      this.initialize();
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    customFilter(value, search, item) {
      if (!search) return true;

      // Convert search to lowercase for case-insensitive comparison
      search = search.toLowerCase();

      // Check if the primary fields match
      const matchesCustomer = item.customerName.toLowerCase().includes(search);
      const matchesPoNumber = item.poNumber.toLowerCase().includes(search);
      const matchesInvoiceNumber = item.invoiceNumber.toString().includes(search);
      const matchesJournalDate = item.matchesJournalDate.toString().includes(search);
      const matchesHppAmount = item.hppAmount.toString().includes(search);
      const matchesInvoiceAmount = item.invoiceAmount.toString().includes(search);
      const matchesAmount = item.amount.toString().includes(search);
      const matchesHasBomList =
        (item.hasBomList && "ada".includes(search)) ||
        (!item.hasBomList && "kosong".includes(search));

      // Check if any of the listItem values match
      const matchesListDo =
        item.listDo.some(i => i.doNumber?.toLowerCase().includes(search)) || false;

      // Return true if any of the conditions match
      return (
        matchesCustomer ||
        matchesPoNumber ||
        matchesInvoiceNumber ||
        matchesJournalDate ||
        matchesHppAmount ||
        matchesInvoiceAmount ||
        matchesAmount ||
        matchesHasBomList ||
        matchesListDo
      );
    },
  },
};
</script>

<style></style>
